import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Home/PendingGoodReceiving';

const PendingGoodReceiving = () => ((orgContainer(InnerComponent)));

export default PendingGoodReceiving;
